import React from 'react'
import Swal from 'sweetalert2'
import {makeStyles, useTheme} from "@material-ui/core";
import {isEmpty, isNull, isUndefined} from 'lodash'
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
    container: {
      zIndex: 10000,
      paddingBottom: '50px !important',
      paddingRight: '20px !important'
    },
    popup: {
      animation: '',
      transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      width: '24em',
      overflow: 'hidden',
      borderRadius: 8,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      padding: '10px 16px !important'
    },
    popups: {
      animation: '',
      transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: '400',
        color: theme.typography.h1.color
    },
    closeButton: {
        color: theme.palette.text.primary,
        paddingBottom: '3px !important',
        '&:focus': {
            boxShadow: 'none',
        },
        '&:hover': {
            color: theme.typography.h1.color
        }
    },
    image: {
      margin: theme.spacing(0, 'auto', 2),
    },
    htmlContainer: {
        fontSize: '1rem',
        lineHeight: 1.5,
        margin: theme.spacing(1, 3, .5),
        height: 'calc(100% - 11px) !important',
        '& a': {
            textDecoration: 'none',
            color: theme.palette.primary.main,
        }
    },
    confirmButton: {
        border: 0,
        margin: '.3125em',
        cursor: 'pointer',
        color: theme.palette.common.white,
        boxSizing: 'border-box',
        fontSize: '0.875rem',
        lineHeight: 1.75,
        padding: theme.spacing(.75, 2),
        borderRadius: 4,
        fontFamily: 'inherit',
        backgroundColor: theme.palette.primary.main,

        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        }
    },
    cancelButton: {
        border: 0,
        margin: '.3125em',
        cursor: 'pointer',
        color: theme.palette.common.white,
        boxSizing: 'border-box',
        fontSize: '0.875rem',
        lineHeight: 1.75,
        padding: theme.spacing(.75, 2),
        borderRadius: 4,
        fontFamily: 'inherit',
        backgroundColor: theme.palette.grey[600],

        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.grey[700],
        }
    },
    footer: {
        marginTop: '1.5rem',
        fontSize: '.875rem',
        borderColor: theme.palette.divider,
        '& a': {
            textDecoration: 'none',
            color: theme.palette.primary.main,
        }
    }
}))

// type
// - success
// - error
// - warning
// - info
// - question

// loading
// - true
// - false

// msg
// - ""


export default function Toaster(props) {

  const sweetAlertStyles = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme();

  const [currentRes, setCurrentRes] = React.useState(null)

  React.useEffect(() => {
    if(!isNull(props.response) && !isUndefined(props.response) && !isEmpty(props.response)) {
      // if(JSON.stringify(props.response) !== JSON.stringify(currentRes)) 
      // setCurrentRes(JSON.stringify(props.response))
      sweetAlerts(props.response.type, props.response.msg, props.response.loading)
      // setCurrentRes(props.response)
    } 
  },[props.response?.type, props.response?.msg, props.response?.loading])
  React.useEffect(() => {
    return () => {
        Swal.close()
    };
  }, []);

  const sweetAlerts = (variant, msg, loading) => {
    const Toast = Swal.mixin({
        toast: true,
        iconHtml: props.response.loading ? '<div class="swal2-loader" style="display: flex; width: 42px; height: 42px; border-width: 4px; background-color: #fff;"></div>' : undefined,
        position: 'bottom-end',
        showConfirmButton: false,
        showCloseButton: props.response.type === 'error' ? true : props.response.loading || props.response.type !== 'success' || props.response.type !== 'warning' ? false : true,
        timer: !props.response.loading && props.response.type !== 'error' ? (props.response.type === 'success' ? 3000 : 3000) : undefined, // Fixed timer logic
        timerProgressBar: true, // Enable timer progress bar for better visibility
        didOpen: (toast) => {
            if (props.response.loading) Swal.showLoading(toast); // Ensure loading state works
        },
        showClass: { 
          popup: `${sweetAlertStyles.popups}`,
        },
        customClass: {
          container: `${sweetAlertStyles.container}`,
          popup: `${sweetAlertStyles.popup}`,
          title: `${sweetAlertStyles.title}`,
          closeButton: `${sweetAlertStyles.closeButton}`,
          image: `${sweetAlertStyles.image}`,
          htmlContainer: `${sweetAlertStyles.htmlContainer}`,
          confirmButton: `${sweetAlertStyles.confirmButton}`,
          cancelButton: `${sweetAlertStyles.cancelButton}`,
          footer: `${sweetAlertStyles.footer}`,
        },
        buttonsStyling: false
    });    
    Toast.fire({
      icon: variant,
      html: `
      <div class="mb-0 h-100 w-100 d-flex align-items-center justify-content-between">
        <span>${msg}</span>
      </div>`,
      background: theme.palette.background.paper,
    }).then(() => {
      //if (!isUndefined(props.onCloseToaster)) props.onCloseToaster();
      if (!isUndefined(props.resetResponseActionType)) dispatch({ type: props.resetResponseActionType });
    });
  };

  return (
    <></>
  )
}
